import React from 'react';
import Tab from './ui/Tab';

const HeaderToggleTab = ({ isHeaderVisible, toggleHeader }) => {
  // Tab is fully visible when header is hidden
  // Tab shows only sliver when header is visible
  // Constrained to top edge for horizontal dragging only
  return (
    <Tab
      position="top"
      image="/images/header.png"
      alt="4RKED Logo - Toggle Header"
      onClick={toggleHeader}
      isVisible={!isHeaderVisible}
      sliverSize={10}
      storageKey="headerTabPosition"
      constrainToEdge={true}
    />
  );
};

export default HeaderToggleTab;

